import axios from 'axios';
import { STATE_MAPPING } from '../common/constants';

export function loadShopperDoctors(username, zipcode, planCPS, planYear) {
  const token = window.localStorage.getItem('SessionToken');

  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/provider/`,
      headers: { Authorization: `Token ${token}` },
      params: { shopper: username },
    }).then((res) => {
      let rfmDoctors = res.data.map((doc) => ({
        address: doc.address,
        address2: doc.address2,
        city: doc.city,
        coveredPlans: doc.covered_plans,
        effectiveness: doc.effectiveness,
        efficiency: doc.efficiency,
        id: doc.id,
        important: doc.important,
        latitude: doc.latitude,
        longitude: doc.longitude,
        name: doc.name,
        npi: doc.npi,
        phone: doc.phone,
        providerType: doc.provider_type,
        specialties: doc.specialties,
        state: doc.state,
        zipcode: doc.zipcode,
        group: doc.group,
        ipa: doc.ipa,
        hospital: doc.hospital,
      }));

      axios({
        method: 'get',
        url: `${process.env.REACT_APP_MMB_API_URL}/api/utils/provider/${zipcode}/none/`,
        headers: { Authorization: `Token ${token}` },
        params: {
          cps_ids: planCPS,
          nosearch: true,
          npis: rfmDoctors.map((doc) => doc.npi).join(','),
          plan_year: planYear,
        },
      }).then(({ data }) => {
        rfmDoctors = rfmDoctors.map((doctor) => {
          let pcpID = null;
          let externalID = null;
          let acceptingNewPatients = null;
          data.forEach((d) => {
            if (String(d.id) === String(doctor.npi)) {
              d.networks.forEach((n) => {
                n.addresses.forEach((a) => {
                  if (a.pcp
                    && ((doctor.address || '').toLowerCase().trim() === (a.street_line_1 || '').toLowerCase().trim())) {
                    pcpID = a.pcp_id;
                    externalID = a.external_id;
                    acceptingNewPatients = a.accepting_new_patients;
                  }
                });
              });
            }
          });
          return {
            ...doctor,
            pcpID,
            externalID,
            acceptingNewPatients,
          };
        });
        resolve(rfmDoctors);
      }).catch((err) => reject(err));
    }).catch((err) => reject(err));
  });
}

export function doctorSearch(zipcode, searchString, radius = null, skill = null, planIDs = [], planYear) {
  const token = window.localStorage.getItem('SessionToken');
  const st = !searchString ? 'none' : searchString;

  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      headers: { Authorization: `Token ${token}` },
      params: {
        radius,
        skills: skill,
        nosearch: st === 'none',
        cps_ids: planIDs.join(',') || undefined, // comma separated cps ids
        plan_year: planYear,
      },
      url: `${process.env.REACT_APP_MMB_API_URL}/api/utils/provider/${zipcode}/${st}/`,
    })
      .then((res) => {
        const rfmData = [];
        res.data.forEach((doctor) => {
          const { networks = [] } = doctor;
          let addresses = [];
          networks.forEach((n) => {
            addresses = addresses.concat(n.addresses);
          });
          addresses.forEach((location) => {
            let { state } = location;
            let { phone } = doctor;
            const phoneNumbers = location.phone_numbers;
            if (STATE_MAPPING[state]) {
              state = STATE_MAPPING[state];
            }
            if (phoneNumbers && phoneNumbers.length) {
              [phone] = phoneNumbers;
            }
            if (location.pcp) {
              rfmData.push({
                npi: String(doctor.id),
                name: (doctor.presentation_name || '').trim(),
                address: (location.street_line_1 || '').trim(),
                address2: (location.street_line_2 || '').trim(),
                latitude: location.latitude,
                longitude: location.longitude,
                city: (location.city || '').trim(),
                state: (state || '').trim(),
                phone: (phone || '').trim(),
                zipcode: location.zip_code,
                coveredPlans: [],
                specialties: doctor.specialties,
                providerType: doctor.type,
                addressID: location.address_id,
                efficiency: location.efficiency, // humana only field
                effectiveness: location.effectiveness, // humana only field
                group: (location.group || '').trim(),
                ipa: (location.ipa || '').trim(),
                hospital: (location.hospital || '').trim(),
                pcpID: (location.pcp_id || '').trim(),
                externalID: (location.external_id || '').trim(),
                acceptingNewPatients: location.accepting_new_patients,
              });
            }
          });
        });
        resolve(rfmData);
      }).catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}

export function loadDoctorSpecialties() {
  const token = window.localStorage.getItem('SessionToken');

  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/utils/provider/specialties/`,
      headers: { Authorization: `Token ${token}` },
    }).then((res) => {
      resolve(res.data);
    }).catch((err) => {
      reject(err);
    });
  });
}
